import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { createFileRoute } from "@tanstack/react-router";
import { FileText, Info, Mail, MessageSquareMore } from "lucide-react";
import { SupportLinkRow } from "~/components/SupportLinkRow";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";
import { useHelp } from "~/contexts/HelpContext";

export const Route = createFileRoute("/support/")({
	beforeLoad: () => {
		document.title = "bacehub | Chat & Support";
	},
	component: RouteComponent,
});

export default function RouteComponent() {
	const { openIntercom, unreadCount } = useHelp();
	const i18n = useI18nContext().LL["new-ui"];
	const supportItems = [
		{
			icon: Info,
			title: i18n.HOW_TO_USE(),
			to: "/support/how-to-use",
		},
		{
			icon: MessageSquareMore,
			title: i18n.LIVE_CHAT(),
			onClick: openIntercom,
			badgeLabel: unreadCount > 0 ? i18n.NEW_MESSAGES() : undefined,
		},
		{
			icon: Mail,
			title: i18n.CONTACT_US(),
			linkProps: { href: "mailto:support@bacehub.de", target: "_blank", rel: "noreferrer" },
		},
		{
			icon: FileText,
			title: i18n.TERMS_CONDITIONS(),
			linkProps: { href: "https://bacehub.de/privacy-policy", target: "_blank", rel: "noreferrer" },
		},
	];

	return (
		<PageContainer>
			<AppHeader service="ALL" />
			<h1 className="px-6 py-2 text-2xl font-breit">
				<T>{i18n.CHAT_AND_SUPPORT()}</T>
			</h1>
			<div className="mx-6">
				{supportItems.map((item) => (
					<SupportLinkRow key={item.title} {...item} />
				))}
			</div>
		</PageContainer>
	);
}
